import * as tslib_1 from "tslib";
import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { ModalController } from '@ionic/angular';
import { AuthGuard } from './guards/auth.guard';
import { AuthReverseGuard } from './guards/auth-reverse.guard';
// Services
import { AuthService } from 'src/app/services/auth.service';
import { ConfigService } from 'src/app/services/config.service';
import { ToolsService } from 'src/app/services/tools.service';
import { ModalCompleteInformationPage } from 'src/app/modals/modal-complete-information/modal-complete-information.page';
// import { Events } from '@ionic/angular';
import { FormControl, Validators } from '@angular/forms'; //Borrar
import { CatalogueGuard } from './guards/catalogue.guard';
import { ShoppingCartGuard } from './guards/shopping-cart.guard';
import { ReferralGuard } from './guards/referral.guard';
import { AutomaticPointsSettingsPage } from './modals/automatic-points-settings/automatic-points-settings.page';
export class AppComponent {
    constructor(platform, splashScreen, statusBar, configService, authService, modalController, 
    // private events: Events,
    toolsService, authGuard, authReverseGuard, catalogueGuard, shoppingCartGuard, referralGuard) {
        this.platform = platform;
        this.splashScreen = splashScreen;
        this.statusBar = statusBar;
        this.configService = configService;
        this.authService = authService;
        this.modalController = modalController;
        this.toolsService = toolsService;
        this.authGuard = authGuard;
        this.authReverseGuard = authReverseGuard;
        this.catalogueGuard = catalogueGuard;
        this.shoppingCartGuard = shoppingCartGuard;
        this.referralGuard = referralGuard;
        this.initializeApp();
        this.configService.getEvents().subscribe((event) => {
            if (event.name != 'checkInfo')
                return;
            console.debug("checkInfo");
            this.checkPlayer();
        });
    }
    initializeApp() {
        this.platform.ready().then(() => {
            this.statusBar.styleDefault();
            this.splashScreen.hide();
        });
        this.checkPlayer();
    }
    checkPlayer() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let isLogged = yield this.authService.checkAutentication();
            if (isLogged) {
                let playerData = yield this.authService.getPlayerFullData();
                if (!this.configService.company_info)
                    yield this.configService.getLoadedCompany();
                yield this.authService.updateNumberLogin(playerData.number_of_logins);
                if (playerData.number_of_logins >= (this.configService.company_info.number_of_logins - 1) && playerData.ask_info && this.configService.company_info.ask_user_info)
                    this.checkInfo(playerData);
                if (this.configService.company_info.wallet_automatic_redemption) {
                    if (playerData.automatic_redemption_wallet == null) {
                        return this.presentAutomaticPointsModal();
                    }
                }
            }
        });
    }
    checkInfo(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.debug("checkInfo", data, this.configService.company_info);
            let questions_aux = [
                { name: 'born_date', label: 'Fecha de nacimiento', format: 'date', type: 'date', formControl: new FormControl('', [Validators.required, Validators.minLength(8)]) },
                { name: 'gender', label: 'Género', format: 'select', options: [{ name: "Masculino", value: "MALE" }, { name: "Femenino", value: "FEMALE" }], formControl: new FormControl('', [Validators.required, Validators.maxLength(30)]) },
                { name: 'document_type', label: 'Tipo de identificación', format: 'select', options: [{ name: "Cédula de ciudadanía", value: "CC" }, { name: "NIT", value: "NIT" }, { name: "Pasaporte", value: "PASSPORT" }], formControl: new FormControl('', [Validators.required, Validators.maxLength(30)]) },
                { name: 'cellphone', label: 'Celular', format: 'input', type: 'number', formControl: new FormControl('', [Validators.required, Validators.maxLength(10)]) },
                { name: 'document', label: 'N° de identificación', format: 'input', type: 'number', formControl: new FormControl('', [Validators.required]) },
                { name: 'servientrega_city', label: 'Ciudad', format: 'autocomplete', type: 'text', search_url: '/crm/get_cities', formControl: new FormControl('', [Validators.required]) },
            ];
            let empty_info = [];
            for (var key in data) {
                if (data[key] == null || data[key] == "")
                    empty_info.push(key);
            }
            let empty_basic_info = questions_aux.filter(question => empty_info.indexOf(question.name) > -1);
            let empty_additional_info = [];
            let aditional_questions = yield this.toolsService.formatQuestions(this.configService.company_info.user_questions);
            for (let question of aditional_questions) {
                if (question.label in data.additional_info) {
                    if (data.additional_info[question.label] == null || data.additional_info[question.label] == "")
                        empty_additional_info.push(question);
                }
                else if (!(question.label in data)) {
                    empty_additional_info.push(question);
                }
            }
            if (empty_basic_info.length > 0 || empty_additional_info.length > 0) {
                this.presentCodeModal(empty_basic_info, empty_additional_info);
            }
        });
    }
    presentCodeModal(questions, additional_questions) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const modal = yield this.modalController.create({
                component: ModalCompleteInformationPage,
                backdropDismiss: false,
                componentProps: {
                    questions: questions,
                    additional_questions: additional_questions,
                }
            });
            modal.onDidDismiss()
                .then((response) => {
            });
            return yield modal.present();
        });
    }
    presentAutomaticPointsModal() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const modal = yield this.modalController.create({
                component: AutomaticPointsSettingsPage,
                backdropDismiss: true,
                cssClass: 'autopoints-modal-class',
            });
            modal.onDidDismiss().then((response) => { });
            return yield modal.present();
        });
    }
    getCustomCss() {
        return this.configService.getCustomCss();
    }
}
